import { Page, PurchasedPackage } from '@/domains';

import { authorizedApi } from '@/services/network/authorized-api';

export const getPurchasedPackages = (pageNumber: number, pageSize: number, options?: { [x: string]: any }) =>
  authorizedApi.get<Page<PurchasedPackage>>(`/admin/packages`, { pageNumber, pageSize, ...options });

export const refundPackage = (packageId: string) => authorizedApi.post(`/admin/packages/${packageId}/refund`);
